<mat-toolbar>
    <button (click)="drawer.toggle()" mat-icon-button class="example-icon" aria-label="Example icon-button with menu icon">
        <mat-icon>menu</mat-icon>
    </button>
    <span>Pagina di test del Ippica</span>
    <span class="example-spacer"></span>
    <button mat-icon-button class="example-icon favorite-icon" aria-label="Example icon-button with heart icon">
        <mat-icon>favorite</mat-icon>
    </button>
    <button mat-icon-button class="example-icon" aria-label="Example icon-button with share icon">
        <mat-icon>share</mat-icon>
    </button>
</mat-toolbar>
<mat-drawer-container class="example-container" [hasBackdrop]="true">
        <mat-drawer #drawer [mode]="'over'">
            <div class="opt-test">
                <mat-form-field appearance="fill">
                    <mat-label>Tipo di Frame</mat-label>
                    <mat-select (selectionChange)="changeFrame($event.value)" [(ngModel)]="type">
                        <mat-option [value]="'bet'">Bet</mat-option>
                        <mat-option [value]="'ticket'">Ticket</mat-option>
                    </mat-select>
                    <mat-hint align="end">Modifica il tipo di frame</mat-hint>
                </mat-form-field>
            </div>
            <mat-divider></mat-divider>
            <div class="opt-test">
                <mat-form-field appearance="fill">
                    <mat-label>cID</mat-label>
                    <mat-select (selectionChange)="changeCid($event)" [(ngModel)]="cID" >
                        <mat-option [value]="'fff'">No CID</mat-option>
                        <mat-option *ngFor="let cidStagign of getCidByEnv(this.enviromentStaging.cID); let i = index;" [value]="cidStagign">{{this.enviromentStaging.cID[cidStagign].name}}</mat-option>
                    </mat-select>
                    <mat-hint align="end">cID partner staging</mat-hint>
                </mat-form-field>
            </div>
            <mat-divider></mat-divider>
            <div class="opt-test">
                <mat-form-field class="example-full-width" appearance="fill">
                    <mat-label>Sessione</mat-label>
                    <input #sIDinput matInput placeholder="Sessione Utente" value="{{sID}}">
                    <mat-hint align="end">sID Sessione del cliente</mat-hint>
                </mat-form-field>
            </div>
            <div class="opt-test">
                <button mat-stroked-button color="primary" (click)="changeSid(sIDinput.value)">Accedi</button>
            </div>
            <div class="opt-test">
                <button mat-stroked-button color="warn" (click)="logOut()">Log Out</button>
            </div>
            <mat-divider></mat-divider>
        </mat-drawer>
    <mat-drawer-content>
        <div id="mst-content"></div>
    </mat-drawer-content>
</mat-drawer-container>
<div style="height: 54px; background: red"></div>

